import { SCREEN_SIZE } from "./screenSize";
import ROUTES from "./routes";
import { EVENT } from "./events";

const CONSTANTS = {
	SCREEN_SIZE,
	ROUTES,
	EVENT
};

export default CONSTANTS;